import animateScrollTo from 'animated-scroll-to';

(function() {
	const bodyElement = document.body;
	const hash = window.location.hash;
	const scrollToElements = document.querySelectorAll('[data-scroll-to]');

	const scrollTo = (id) => {
		if (id) {
			const el = document.getElementById(id);

			if (el) {
				const rect = bodyElement.getBoundingClientRect();
				const verticalOffset = -(rect.top + window.scrollY);

				animateScrollTo(el, { verticalOffset });
			}
		}
	};

	scrollToElements.forEach((element) => {
		element.addEventListener('click', (e) => {
			e.preventDefault();
			e.stopImmediatePropagation();
			const dataValue = element.getAttribute('data-scroll-to');
			scrollTo(dataValue);
		});
	});

	if (hash) {
		setTimeout(() => {
			scrollTo(hash.substring(1));
		}, 1100);
	}

	window.addEventListener('popstate', function() {
		const hashState = window.location.hash;

		if (hashState) {
			scrollTo(hashState.substring(1));
		}
	});
}());
